
import { defineComponent } from "vue";

export default defineComponent({
  props: ["data"],
  setup() {},
});
